import { Stack, Typography, IconButton, Box, Tooltip } from '@mui/material';
import { Link } from 'react-router';
import { useSelector } from 'src/store';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { useState, useCallback, useEffect, useRef } from 'react';
import Logo from 'src/assets/images/jarrell.png';

const StaffTitle = () => {
  const isEventPage = location.pathname.startsWith('/event');
  const isGigsByDayPage = location.pathname.startsWith('/gigs-by-day');
  const eventName = useSelector((state) => state.activeEvent.name);
  const eventId = useSelector((state) => state.activeEvent.id);
  const [showCopyIcon, setShowCopyIcon] = useState(false);
  const [copied, setCopied] = useState(false);
  const isHovering = useRef(false);

  // Show custom title logic:
  // - On event pages: show eventName if we have an actual event ID
  // - On gigs-by-day page: show "Gigs by Day" 
  // - Otherwise: show default branding
  const shouldShowCustomTitle = 
    (isEventPage && eventId && eventId.trim() !== '') || 
    (isGigsByDayPage && eventName === 'Gigs by Day');
  const displayTitle = shouldShowCustomTitle ? eventName : 'Jarrell Entertainment';

  const handleCopy = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    navigator.clipboard
      .writeText(eventName)
      .then(() => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
          // Only show the copy icon after timeout if still hovering
          if (!isHovering.current) {
            setShowCopyIcon(false);
          }
        }, 1500);
      })
      .catch((err) => console.error('Failed to copy text: ', err));
  };

  const handleMouseEnter = useCallback(() => {
    isHovering.current = true;
    setShowCopyIcon(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    isHovering.current = false;
    // Only hide the copy icon if we're not in a "copied" state
    if (!copied) {
      setShowCopyIcon(false);
    }
  }, [copied]);

  return (
    <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
      <Box 
      sx={{ 
        height: '40px', 
        display: 'flex', 
        alignItems: 'center' 
      }}
      component={Link}
      to="/staff"
      >
      <img
        src={Logo}
        alt="Jarrell Entertainment"
        style={{
        maxHeight: '100%',
        width: 'auto',
        objectFit: 'contain'
        }}
      />
      </Box>
      {shouldShowCustomTitle ? (
      <Box
        sx={{
        display: 'flex',
        position: 'relative',
        alignItems: 'center'
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Typography variant="h6" color="primary.main" component={Link} to="/staff" sx={{ textDecoration: 'none' }}>
        {displayTitle}
        </Typography>
        {(showCopyIcon || copied) && (
        <Tooltip title="Copy event name">
          <IconButton
          size="small"
          onClick={handleCopy}
          sx={{ ml: 0.5, opacity: copied ? 1 : 0.7 }}
          aria-label="Copy event name to clipboard"
          >
          {copied ? <CheckIcon fontSize="small" color="success" /> : <ContentCopyIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
        )}
      </Box>
      ) : (
      <Typography variant="h6" color="primary.main" component={Link} to="/staff" sx={{ textDecoration: 'none' }}>
        {displayTitle}
      </Typography>
      )}
    </Stack>
  );
};
export default StaffTitle;
